// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorSearchResponseModel {
    static getAttributeTypeMap() {
        return PayorSearchResponseModel.attributeTypeMap;
    }
}
PayorSearchResponseModel.discriminator = undefined;
PayorSearchResponseModel.attributeTypeMap = [
    {
        "name": "payors",
        "baseName": "payors",
        "type": "Array<PayorModel>"
    },
    {
        "name": "hasAdditionalMatches",
        "baseName": "hasAdditionalMatches",
        "type": "boolean"
    }
];
//# sourceMappingURL=payorSearchResponseModel.js.map